var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":"Unit assigned to the incident","items":_vm.itemsPrepared,"error-messages":_vm.errorMessages,"loading":_vm.unitsLoading,"outlined":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }